<!--
  画面名：計画書表紙
  画面概要：計画書の表紙を表示する
  備考：-
-->

<template>
  <div class="book" @click="click">
    <!-- 会社名 -->
    <span class="font company">{{companyName}}</span>
    <!-- 初版作成日 -->
    <span class="font first">{{$language.LabelFirstTime}}:{{first}}</span>
    <!-- 最新改定日 -->
    <span class="font update">{{$language.LabelUpdateTime}}:{{update}}</span>
    <!-- タイトル -->
    <span class="font book-title">{{$language.LabelHygieneManagementPlan}}</span>
    <!-- 作成責任者 -->
    <span class="font create">{{$language.LabelCreateManagemenr}} : {{creat}}</span>
    <!-- 実施責任者 -->
    <span class="font plan">{{$language.LabelDoManager}} : {{plan}}</span>
    <!-- 承認者 -->
    <span class="font confirm">{{$language.LabelAuthorizer}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: {{confirm}}</span>
  </div>
</template>

<script>
export default {
  props: {
    companyName: { type: String, default: '[会社名]' },
    first: { type: String, default: '[年月日]' },
    update: { type: String, default: '[年月日]' }
  },
  data () {
    return {
      creat: '食品安全チームリーダー',
      plan: '各店舗の食品衛生責任者',
      confirm: '代表取締役'
    }
  },
  methods: {
    // クリック処理
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/systemConfig/planBook.scss';
</style>
